import './shared/lib/i18n'; // Must be first — initializes i18next before React renders
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './styles/globals.css';
import { App } from './app/App';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN || '';
const sentryEnabled = sentryDsn.startsWith('https://');

Sentry.init({
  dsn: sentryEnabled ? sentryDsn : undefined,
  environment: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION || 'dev',
  enabled: sentryEnabled,
  tracesSampleRate: 0.1,
  // Never capture auth tokens or API keys in breadcrumbs
  beforeBreadcrumb(breadcrumb) {
    if (
      breadcrumb.category === 'xhr' &&
      typeof breadcrumb.data?.['url'] === 'string' &&
      breadcrumb.data['url'].includes('/auth/')
    ) {
      return null;
    }
    return breadcrumb;
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
